module.exports = __webpack_public_path__ + "img/bi@2x.97614a3c.png";